<section class="section-white">
  <div class="section-container-inside">
    <span class="product-blog-subheading mar-b-16 align-c">{{
      embeddedCollectionData?.tags?.[0]?.fields?.tagText
    }}</span>
    <h2 class="section-heading mar-b-32 align-c">
      <span class="wid-75">{{ embeddedCollectionData?.title }}</span>
    </h2>
    <div
      class="section-description mar-b-48"
      [innerHtml]="embeddedCollectionData?.richTextTitle | toHtml"
    ></div>
    <div class="financial-stack grey-100 align-l">
      <div class="product-hero-content-box">
        <div>
          <h2 class="section-heading mar-b-32">
            {{ embeddedCollectionData?.component1?.[0]?.fields?.title }}
          </h2>
          <div
            class="section-description mar-b-32 align-l"
            [innerHtml]="embeddedCollectionData?.component1?.[0]?.fields?.description | toHtml"
          ></div>
          <a
            *ngIf="embeddedCollectionData?.component1?.[0]?.fields?.button?.[0]?.fields?.buttonText"
            href="{{ embeddedCollectionData?.component1?.[0]?.fields?.button?.[0]?.fields?.redirectLink }}"
            class="btn btn-full"
            >{{ embeddedCollectionData?.component1?.[0]?.fields?.button?.[0]?.fields?.buttonText }}</a
          >
        </div>
        <img
          src="{{ embeddedCollectionData?.component1?.[0]?.fields?.imageicon?.fields?.file?.url }}"
          loading="lazy"
        />
      </div>
    </div>
    <div class="bottom-cards">
      <div class="section-efficient-payment">
        <div class="dummy">&nbsp;</div>
        <ng-container *ngFor="let content of embeddedCollectionData?.component1; let i = index">
          <div
            *ngIf="i !== 0"
            class="efficient-payment pointer"
            [ngClass]="
              i === 1
                ? 'padd-32 blue-100'
                : i === 2
                  ? 'padd-32 orange-100'
                    : ''
            "
          >
            <div
              class="product-landing-content"
            >
              <h5 class="efficient-payment-heading">
                {{ content?.fields?.title }}
              </h5>
              <div
                class="efficient-payment-description"
                [innerHtml]="content?.fields?.description | toHtml"
              ></div>
            </div>
            <figure>
              <img
                loading="lazy"
                src="{{ content?.fields?.imageicon?.fields?.file?.url }}"
              />
            </figure>
          </div>
        </ng-container>
        <div class="dummy">&nbsp;</div>
      </div>
    </div>
  </div>
</section>
